var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox-dropdown',{staticClass:"pt-5",attrs:{"checked-values":_vm.value,"options":_vm.channelOptions,"is-no-value-allowed":true,"grid-cols":"2","hide-footer":true},on:{"change":function($event){return _vm.onToggleCheckbox($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }